import { parseSupportedLanguageOrDefault } from '@pmi.web/localization';

import { HelpCarousel } from './HelpCarousel';
import { Translatable } from './Translatable';

interface IVirtualWarehouseHelpCarouselProps {
  readonly language: string;
  readonly onComplete?: () => void;
}

export function VirtualWarehouseHelpCarousel(
  props: IVirtualWarehouseHelpCarouselProps,
) {
  const language = parseSupportedLanguageOrDefault(props.language);

  return (
    <Translatable language={language}>
      <HelpCarousel onComplete={props.onComplete} />
    </Translatable>
  );
}
